import React , { useEffect, useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { logoutCredential,selectedDestinationDropdownCredential,selectedpassengerCredential
  ,searchCredential,PaymentTypeDropdownCredential,FeeServiceDropdownCredential,
  selectedOriginDropdownCredential, flightManifestDetails, setSidemenuFlag,moduleDropdown, seatIdentificationCredential, flightSearchCredential,
  flightManifestBoardingCredential,
  flightTripBoardingCredential,
  setflightLegKeyCredential,
  assistQueueCredential, redirectToPageCredentials, moduleAndLoginDivDisabled, FetchPrintModeModalStatus } from '../ReduxState';
import {useHistory, useLocation, NavLink} from 'react-router-dom';
import {fncLogoutApi} from '../Utility/ApiCall.js';
import { toast } from 'react-toastify';
import { sKeys, checkinModule, boardingModule, sKeysForBoarding, isInternationalFlight, notificationModule } from '../Utility/CommonFun.js';
import ReactTooltip from "react-tooltip";
import { useRef } from 'react';
import FocusLock from "react-focus-lock";
function Header({ handleSideMenu }) {
  const IsModulAndLoginDivDisabled = useSelector(state => state.login.IsModulAndLoginDivDisabled);
  const moduleDivRef =useRef(null);
  const location = useLocation();
  
  const UserRights= useSelector(state=>state.login.CheckInRights);
  const UserBoardingRights = useSelector(state => state.login.BoardingRights);
  const SearchedRecordData = useSelector(state => state.search.SearchedRecordData);
  const SearchedFlightDetails = useSelector(state => state.search.SearchedFlightDetails);
  const sidemenuFlag = useSelector(state => state.sidemenu.sideMenuFlag);
  const manifest = useSelector(state => state.sidemenu);
  const selectedModule = useSelector(state => state.login.Module);
  const flightManifest = useSelector(state => state.flightSearch.flightManifestBoarding);
  const flightTripBoarding = useSelector(state => state.flightSearch.flightTripBoarding);
  const PrintModeModalStatus = useSelector(state => state.printMode.PrintModeModalStatus);      
  // const [stSearchedRecordData, setSearchedRecordData] = useState(SearchedRecordData.length === 0 ? [] : SearchedRecordData);
  const notify = (e, autoClose) => 
  toast.error(e, {
      position: "top-right",
      autoClose: autoClose,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      });

      const notifySuccess = (e) => 
      toast.success(e, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });

  
  const dispatch = useDispatch()
  let history = useHistory();
  const UserName= useSelector(state=>state.login.UserName);
  const Role= useSelector(state=>state.login.Role);
  const Id= useSelector(state=>state.login.Id);
  const IsLogin= useSelector(state=>state.login.IsLogin);
  // const [hideSecurity, sethideSecurity] = useState(true);
          // console.log('UserRights', UserRights);

  let showUserRights = false;
  let hideSecurity = true;

  function sortByProperty(property){  
    return function(a,b){  
       if(a[property] === 'Security')  
          return -1;  
      // else if(a[property] < b[property])  
         //  return -1;  
   
       return 0;  
    }  
  }

  if(UserRights.filter(item => item.key === 'SecurityTravelDoc').length) {
  UserRights.sort(sortByProperty('value'));
  const temp = UserRights[0];
  UserRights[0] = UserRights[1];
  UserRights[1] = temp;
  // console.log(UserRights);
  }

  hideSecurity = isInternationalFlight(SearchedFlightDetails);

  if (selectedModule === checkinModule && SearchedFlightDetails && SearchedFlightDetails.recordLocator) {
    for(let i = 0; i < SearchedFlightDetails.journeys.length; i++) {
      if (SearchedFlightDetails.journeys[i].segments.some(seg => seg.IsSelected)) {
        showUserRights = true;
        break;
      } else {
        showUserRights = false;
      }
    }
  }

  if (selectedModule === boardingModule && (flightManifest || flightTripBoarding)) {
    showUserRights = true;
  }

function fncMoveToHome()
{
  
  // console.log('location.pathname', location.pathname);
  if (location.pathname !== '/Search' && selectedModule === checkinModule) {
    dispatch(searchCredential(
      {
        type: "",
        SearchedRecordData: [],
        SearchedFlightDetails: {}
      }
    ));
    
    dispatch(selectedpassengerCredential(
      {
        type: "",
        SelectedPassengerData: {},
  
      }
    ));
    dispatch(flightManifestDetails(
      {
        type: "",
        manifestDetails: null
      }
    ));
    history.push('/Search')
  } else if (location.pathname !== '/FlightSearch' && selectedModule === boardingModule) {
    dispatch(flightSearchCredential(
      {
          type: "",
          flightList: []
      }))
      dispatch(flightManifestBoardingCredential(
        {
            type: '',
            flightManifestBoarding: null
        }
    ))
    dispatch(flightTripBoardingCredential(
        {
            type: '',
            flightTripBoarding: null
        }
    ))
    dispatch(assistQueueCredential(
        {
            type: "",
            assistQueue: [],
        }
    ))
    dispatch(setflightLegKeyCredential({
      type: '',
      selectedFlight: null
  }));
    history.push('/FlightSearch')
  }
}

const fncOpenMenu = () => {
  // debugger
  // dispatch(setSidemenuFlag(
  //   {
  //     type: "",
  //     sideMenuFlag: !sidemenuFlag,

  //   }
  // ));
  handleSideMenu();
  // if (!['/Search', '/'].includes(location.pathname)) {
  //   handleSideMenu();
  // } else {
  //   notify('Please proceed with a PNR first', 3000);
  // }
}

function fncLogout()
{
  document.getElementById("showAndHideSpinner").style.display="block"; 
 fncLogoutApi()
 .then((returnVal) => {
             
    //  if(returnVal.data.isError==false)
    //  {  
      // localStorage.clear();
      localStorage.removeItem("LoginToken");
      localStorage.removeItem("SITAPrinters");
      dispatch(logoutCredential(
      {
        type:"",
        UserName:"",
        Password:"",
        Role:"",
        Id:0,
        IsLogin:false
      }));

      dispatch(selectedOriginDropdownCredential(
      {
              type:"",
              OriginDropdown:[]              
      }))
      dispatch(selectedDestinationDropdownCredential(
      {
            type:"",
            DestinationDropdown:[]                                                        
      }))

      dispatch(FeeServiceDropdownCredential(
      {
              type:"",
              FeeServiceDropdown:[]                                                        
      }))
      dispatch(PaymentTypeDropdownCredential(
      {
              type:"",
              PaymentTypeDropdown:[]                                                        
      }))
      dispatch(searchCredential(
      {
              type:"",
              SearchedRecordData:[],
              SearchedFlightDetails:[]
      }));
      dispatch(selectedpassengerCredential(
      {
              type:"",
              SelectedPassengerData:[]                                
      }));
      dispatch(moduleDropdown(
        {
          type:"",
          module: checkinModule
        }
      ));
      dispatch(redirectToPageCredentials(
        {
          type: "",
          redirectionPage: '/Search'
        }
      ));
      dispatch(moduleAndLoginDivDisabled({
                                              type: "MODULE_AND_LOGINDIV_DISABLED",
                                              IsModulAndLoginDivDisabled: true
                                          }));
      dispatch(FetchPrintModeModalStatus(
        {
          type: "PRINT_MODE_MODAL_STATUS",
          PrintModeModalStatus: false
        }
      ));                                   
      history.push('/');
  
  document.getElementById("showAndHideSpinner").style.display="none";    
})
.catch(err => console.log("Axios err: ", err))
}

const selectModule = (module) => {
  // console.log('mod', module);
  dispatch(moduleDropdown(
    {
      type:"",
      module: module
    }
  ));
  dispatch(seatIdentificationCredential(
    {
      type: "",
      SeatIdentification: []
    }
  ));

  const goto = module === checkinModule ? '/Search' : module === notificationModule ? '/Notification' : '/FlightSearch';
    history.push(goto);
  }

  const handleClick = (e, item) => {
    if (item.key.toUpperCase()=="SecurityTravelDoc".toUpperCase() && hideSecurity) {
      e.preventDefault();
    }
  }
//   const handleKeyDownFocusForModule= (e) => {
//     if (e.key === "Tab") {
//         if (!e.shiftKey && document.activeElement === document.getElementById('profile')) {
//             e.preventDefault();
//             document.getElementById('module').focus();
//         } else if (e.shiftKey && document.activeElement === document.getElementById('module')) {
//             e.preventDefault();
//             document.getElementById('profile').focus();
//         }
//     }
// };
const handleKeyDownFocusForModule = (e) => {
  const profileBtn = document.getElementById('profile');
  const moduleBtn = document.getElementById('module');

  if (e.key === "Tab") {
      if (!e.shiftKey && document.activeElement === profileBtn) {
          const isProfileOpen = profileBtn.getAttribute('aria-expanded') === 'true';
          if (isProfileOpen) {
              e.preventDefault();
              const dropdownMenu = profileBtn.nextElementSibling; //dropdown is next sibling
              if (dropdownMenu) {
                  const focusables = dropdownMenu.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])');
                  if (focusables.length > 0) {
                      focusables[0].focus();
                      return;
                  }
              }
          } else {
              e.preventDefault();
              moduleBtn?.focus();
          }
      }

      // Backward Tab: Module ➜ Profile
      else if (e.shiftKey && document.activeElement === moduleBtn) {
          e.preventDefault();
          profileBtn?.focus();
      }

      // Trap focus within profile dropdown if open
      const isProfileOpen = profileBtn?.getAttribute('aria-expanded') === 'true';
      if (isProfileOpen) {
          const dropdownMenu = profileBtn.nextElementSibling;
          const focusables = dropdownMenu?.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])');
          if (focusables?.length > 0) {
              const first = focusables[0];
              const last = focusables[focusables.length - 1];

              if (!e.shiftKey && document.activeElement === last) {
                  e.preventDefault();
                  first.focus();
              } else if (e.shiftKey && document.activeElement === first) {
                  e.preventDefault();
                  last.focus();
              }
          }
      }
  }
};

useEffect(()=>{
dispatch(moduleAndLoginDivDisabled({
                type: "MODULE_AND_LOGINDIV_DISABLED",
                IsModulAndLoginDivDisabled: true
                }));
},[])

  
    return (
      <div  id="HeaderID">
        <header class="header-section">
        <div class="header-link-wrapper-main" tabIndex={-1}>
            <div class="header-link-wrapper d-lg-flex" tabIndex={-1}>
                <div class="d-flex align-items-center">
                    <a class="menu me-3" onClick={fncOpenMenu}>
                        <div class="bar"></div>
                        <div class="bar"></div>
                        <div class="bar"> </div>
                    </a>
                    <a class="" >
                        <img class="site-logo img-fluid" onClick={fncMoveToHome}  src="newImages/logo.png" alt="spiceHealth" />
                    </a>
                </div>
                <div class="header-links">
                    <nav class="header-nav">
                      {showUserRights && selectedModule === checkinModule ?
                      UserRights.map((item)=>
                        <ul key={item.key}>
                          <li>
                            <NavLink tabindex={-1}
                            id={item.key}
                            to={"/"+item.key}
                            onClick={(e) => handleClick(e, item)}>
                              {item.key.toUpperCase()=="Search".toUpperCase()?
                              <div>
                                <img class="white-icon" src="newImages/search-white.svg" alt="search-white" />
                                <img class="dark-icon" src="newImages/search-dark.svg" alt="search-dark" />
                              </div>
                              :
                              item.key.toUpperCase()=="SecurityTravelDoc".toUpperCase()?
                              <div>
                                <img class="white-icon" src="newImages/security-white.svg" alt="security-white" />
                                <img class="dark-icon" src="newImages/security-dark.svg" alt="security-dark" />
                              </div>
                              :
                              item.key.toUpperCase()=="Seat".toUpperCase()?
                              <div>
                                <img class="white-icon" src="newImages/seat-white.svg" alt="seat-white" />
                                <img class="dark-icon" src="newImages/seat-dark.svg" alt="seat-dark" />
                              </div>
                                :
                                item.key.toUpperCase()=="Bags".toUpperCase()?
                              <div>
                                <img class="white-icon" src="newImages/bags-white.svg" alt="bags-white" />
                                <img class="dark-icon" src="newImages/bags-dark.svg" alt="bags-dark" />
                              </div>
                                :
                                item.key.toUpperCase()=="SpiceClub".toUpperCase()?
                              <div>
                                <img class="white-icon" src="newImages/spiceclub-white.svg" alt="spiceclub-white" />
                                <img class="dark-icon" src="newImages/spiceclub-dark.svg" alt="spiceclub-dark" />
                              </div>
                                :
                                item.key.toUpperCase()=="Service".toUpperCase()?
                                  <div>
                                    <img class="white-icon" src="newImages/services-white.svg" alt="services-white" />
                                <img class="dark-icon" src="newImages/services-dark.svg" alt="services-dark" />
                                  </div>
                                :
                                item.key.toUpperCase()=="Payment".toUpperCase()?
                                  <div>
                                    <img class="white-icon" src="newImages/payment-white.svg" alt="payment-white" />
                                    <img class="dark-icon" src="newImages/payment-dark.svg" alt="payment-dark" />
                                  </div>
                                :
                                item.key.toUpperCase()=="Finalize".toUpperCase()?
                                  <div>
                                    <img class="white-icon" src="newImages/finalize-white.svg" alt="finalize-white" />
                                    <img class="dark-icon" src="newImages/finalize-dark.svg" alt="finalize-dark" />
                                  </div>
                                :""
                              } 
                              <span>{item.value} ({`${sKeys[item.key]}`}) </span>
                            </NavLink>
                          </li>                       
                        </ul>
                    )
                    :
                    showUserRights && selectedModule === boardingModule ?
                    UserBoardingRights.map((item)=>
                        <ul key={item.key}>
                          <li>
                            <NavLink tabindex={-1}
                            id={item.key}
                            to={"/"+item.key}>
                              {item.key.toUpperCase()=="FlightSearch".toUpperCase()?
                              <div>
                                <img class="white-icon" src="newImages/search-white.svg" alt="search-white" />
                                <img class="dark-icon" src="newImages/search-dark.svg" alt="search-dark" />
                              </div>
                              :
                              item.key.toUpperCase()=="Overview".toUpperCase()?
                              <div>
                                 <img class="white-icon" src="newImages/overview-white.svg" alt="overview-white" />
                                    <img class="dark-icon" src="newImages/overview-dark.svg" alt="overview-dark" />
                              </div>
                                :
                                item.key.toUpperCase()=="Manifest".toUpperCase()?
                              <div>
                                <img class="white-icon" src="newImages/manifest-white.svg" alt="Manifest-white" />
                                    <img class="dark-icon" src="newImages/manifest-dark.svg" alt="Manifest-dark" />
                              </div>
                                :
                                item.key.toUpperCase()=="Boarding".toUpperCase()?
                              <div>
                                <img class="white-icon" src="newImages/boarding-white.svg" alt="Boarding-white" />
                                    <img class="dark-icon" src="newImages/boarding-dark.svg" alt="Boarding-dark" />
                              </div>
                                :
                                item.key.toUpperCase()=="SeatManagement".toUpperCase()?
                                  <div>
                                    <img class="white-icon" src="newImages/seatManagement-white.svg" alt="seatManagement-white" />
                                    <img class="dark-icon" src="newImages/seatManagement-dark.svg" alt="seatManagement-dark" />
                                  </div>
                                :""
                              } 
                              <span>{item.value} ({`${sKeysForBoarding[item.key]}`})</span>
                            </NavLink>
                          </li>                       
                        </ul>
                    ) :
                    null
                    }                     
                    </nav>
                </div>
                <div class="right-menu d-flex OrangeShadow" tabIndex={-1} onKeyDown={handleKeyDownFocusForModule} ref={moduleDivRef}>
                  <div class="dropdown menu-btn moduleDropdown me-3" >
                      <button  class="focusClass btn round-btn py-0 dropdown-toggle OrangeShadow1 modulebtn" type="button" id="module" data-bs-toggle="dropdown" aria-expanded="false" 
                      tabIndex={IsModulAndLoginDivDisabled ? -1 : 0}

                      >
                          <p class="font-sm dark-text bold mb-0">Module</p>
                          <p class="font-sm grey-text mb-0">{selectedModule}</p>
                      </button>
                      <div class="dropdown-menu py-2" aria-labelledby="module">
                          <ul class="menu-select-list m-0 px-0 pt-2 pb-3">
                              <li tabindex="-1">
                                  <a tabIndex={0} onClick={() => selectModule('Boarding')}
                                  onKeyDown={(e) => {
                                  if (e.key === "Enter") {selectModule('Boarding')}}}
                                  class={selectedModule === 'Boarding' ? "select-item font-md active SerachBtn" : "select-item font-md SerachBtn" }> Boarding</a>
                              </li>
                              <li tabindex="-1">
                                  <a onClick={() => selectModule('Check-In')}
                                  onKeyDown={(e) => {
                                  if (e.key === "Enter") { selectModule('Check-In')}}}
                                  class={selectedModule === 'Check-In' ? "select-item font-md active SerachBtn" : "select-item font-md SerachBtn" } tabIndex={0}> Check-In </a>
                              </li>
                              <li tabindex="-1">
                                  <a onClick={() => selectModule('Notifications')} 
                                  onKeyDown={(e) => 
                                  {if (e.key === "Enter") 
                                  { selectModule('Notifications')}}}
                                  class={selectedModule === 'Notifications' ? "select-item font-md active SerachBtn" : "select-item font-md SerachBtn" } tabIndex={0}> Notifications</a>
                              </li>
                          </ul>
                      </div>
                  </div>
                  <div class="profile-name menu-btn text-end d-flex flex-column justify-content-center d-none d-xl-flex">
                      <p class="mb-0 font-sm dark-text bold">{UserName}</p>
                      <div>
                      <p class="mb-0 font-sm grey-text" data-tip data-for={Role}>{Role}</p>
                      <ReactTooltip id={Role} place="top" effect="solid" >
                        {Role}
                      </ReactTooltip>
                      </div>
                  </div>
                  <div class="dropdown menu-btn profile">
                        <button class="focusClass btn btn-icon btn-grey round-btn dropdown-toggle OrangeShadow1" type="button" id="profile" data-bs-toggle="dropdown" aria-expanded="false" 
                        tabIndex={IsModulAndLoginDivDisabled ? -1 : 0}
                        >
                            <img src="images/profile-img.png" alt="profile" />
                        </button>
                        <div class="dropdown-menu" aria-labelledby="profile">
                            <div class="border-bottom">
                                <p class="font-xl dark-text bold mb-1">{UserName}</p>
                                <p class="font-md grey-text mb-1">{Role}</p>                                
                            </div>

                            {/* <ul class="menu-list m-0 px-0 pt-2 pb-3 border-bottom">
                                <li class="mb-2">
                                    <a href="#" class="menu-item font-md link-dark"> <img class="icon-28" src="newImages/icon-user.svg" alt="profile icon" /> My Profile</a>
                                </li>
                                <li class="mb-2">
                                    <a href="#" class="menu-item font-md link-dark"> <img class="icon-28" src="newImages/icon-password.svg" alt="Change Password" /> Change Password
                                    </a>
                                </li>
                                <li class="mb-2">
                                    <a href="#" class="menu-item font-md link-dark"> <img class="icon-28" src="newImages/icon-setting.svg" alt="Setting" /> Setting</a>
                                </li>
                            </ul> */}
                            <div class="logout pt-2 ">
                                <a onClick={fncLogout} id
                                 onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                      fncLogout();
                                  }}}
                                   class="focusClass menu-item font-md link-dark d-flex justify-content-between OrangeShadow" tabIndex={IsModulAndLoginDivDisabled ? -1 : 0}> Logout
                                  <img class="icon-16" src="newImages/icon-logout.svg" alt="logout" />
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>

    </header>
        
      </div>
    );
  }
  
  export default Header;